/* eslint-disable no-alert */
/* eslint-disable no-console */
import eventBus from '@/js/event-bus';
import { f7 } from 'framework7-vue';

let lastText = '';
let lastScanTime = 0;
let usingFrontCamera = false;

export default {
  async prepareScanner(onScanCallback) {
    if (!window.QRScanner) {
      console.log('QRScanner not supported');
      // If it does not exist, it means it is not supported (for example, web version).
      return;
    }

    const onDone = (err, status) => {
      if (err) {
        console.error(err);
        return;
      }
      if (status.authorized) {
        this.scan(onScanCallback);
        this.showScanner();
      } else if (status.denied) {
        f7.dialog.confirm(this.$t('codeScanner.info.pleaseGrantPermissionsToUseCamera'), () => {
          window.QRScanner.openSettings();
        });
      } else {
        // other status values: QRScanner.Status.{REESTRICTED, NOT_DETERMINED, DENIED, LIGHTING...}
        alert('An error occurred. Please try again.');
      }
    };
    console.log('prepare:', window.QRScanner);
    window.QRScanner.prepare(onDone);
  },
  scan(onScanCallback) {
    window.QRScanner.scan((err, text) => {
      if (err) {
        console.error(err);
        alert(err);
        return;
      }
      const currentTime = Date.now();
      if (text !== lastText || (text === lastText && currentTime - lastScanTime >= 3000)) {
        onScanCallback(text);
        lastText = text;
        lastScanTime = currentTime;
      }
      this.scan(onScanCallback); // re-initiate scanning
    });
  },
  showScanner() {
    window.QRScanner.show();
    if (usingFrontCamera) {
      window.QRScanner.useFrontCamera((err) => {
        if (err) {
          console.error(err);
        }
      });
    }
    this.applyStyles();
    this.emitCameraConfig();
  },
  hideScanner() {
    this.revertStyles();
    this.emitCloseScanner();
    window.QRScanner?.hide();
  },
  destroyScanner() {
    this.revertStyles();
    this.emitCloseScanner();
    window.QRScanner?.destroy();
  },
  emitCameraConfig() {
    window.QRScanner.getStatus((text) => {
      eventBus.emit('openingScanner', text);
    });
  },
  emitCloseScanner() {
    eventBus.emit('closingScanner');
  },
  toggleCamera() {
    if (usingFrontCamera) {
      window.QRScanner.useBackCamera((err) => {
        if (err) {
          console.error(err);
        }
        this.emitCameraConfig();
      });
    } else {
      window.QRScanner.useFrontCamera((err) => {
        if (err) {
          console.error(err);
        }
        this.emitCameraConfig();
      });
    }
    usingFrontCamera = !usingFrontCamera;
  },
  toggleFlash(enable) {
    if (enable) {
      window.QRScanner.enableLight((err) => {
        if (err) {
          console.error(err);
        }
      });
      return;
    }
    window.QRScanner.disableLight((err) => {
      if (err) {
        console.error(err);
      }
    });
  },
  applyStyles() {
    document.body.style.background = 'transparent';

    document.querySelectorAll('.page').forEach((div) => {
      div.style.background = 'transparent';
      div.style.display = 'none';
    });

    document.querySelectorAll('.page-content').forEach((div) => {
      const childPageContent = div.querySelector(':scope > .page-content');

      if (!childPageContent) {
        // Si no hay un hijo '.page-content', oculta este elemento.
        div.style.display = 'none';
      } else {
        // Si hay un hijo '.page-content', establece el fondo del elemento actual en transparente
        // y el display del hijo en 'none'.
        div.style.background = 'transparent';
        childPageContent.style.display = 'none';
      }
    });
    document.querySelectorAll('.escanerCodigoBarras-popup').forEach((div) => {
      div.style.background = 'transparent';
    });
    document.querySelectorAll('.hide-popup-scanner.modal-in, .hide-popup-scanner.panel-in').forEach((div) => {
      div.style.background = 'transparent';
      div.style.display = 'none';
    });
    document.querySelectorAll('.panel-backdrop, .panel-backdrop-in, .popup-backdrop, .backdrop-in').forEach((div) => {
      div.style.background = 'transparent';
    });
  },
  revertStyles() {
    document.body.style.background = '';

    document.querySelectorAll('.page').forEach((div) => {
      div.style.background = '';
      div.style.display = '';
    });

    document.querySelectorAll('.page-content').forEach((div) => {
      // Restablece el display de cada '.page-content' a su valor por defecto.
      div.style.display = '';

      const childPageContent = div.querySelector(':scope > .page-content');

      if (childPageContent) {
        // Restablece el fondo del elemento padre a su valor por defecto.
        div.style.background = '';
        // Restablece el display del hijo '.page-content' a su valor por defecto.
        childPageContent.style.display = '';
      }
    });
    document.querySelectorAll('.escanerCodigoBarras-popup').forEach((div) => {
      div.style.background = '';
    });
    document.querySelectorAll('.hide-popup-scanner.modal-in, .hide-popup-scanner.panel-in').forEach((div) => {
      div.style.background = '';

      // It must be 'block' because if it is empty, the element will not be removed from the DOM
      div.style.display = 'block';
    });
    document.querySelectorAll('.panel-backdrop, .panel-backdrop-in, .popup-backdrop, .backdrop-in').forEach((div) => {
      div.style.background = '';
    });
  },
};
